import { render, staticRenderFns } from "./CourseCancelBulletin.vue?vue&type=template&id=bf235668&"
import script from "./CourseCancelBulletin.vue?vue&type=script&lang=js&"
export * from "./CourseCancelBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports